export enum Certificates {
  PRODUCT = 'product',
  PRODUCT_WITHOUT_BALANCE = 'product-without-balance',
  CANCEL_PRODUCT = 'cancel-product',
  TRANSACTION = 'transaction',
  GOOD_STANDING = 'CONTRACT_CANCELLATION_AND_NON_DEBT',
  ACTIVE_CONTRACT = 'ACTIVE_CONTRACT',
  CONTRACT_WITH_BALANCE = 'CONTRACT_WITH_BALANCE',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  RACT = 'RACT',
}
